import { isUndefined, isNullOrUndefined } from "util";
import store from '@/store/index'
import { resolve } from "path";
import api from "@/api";
import config from "@/config";



let helper = {
    lsstore: null,
    genUUID: () => {
        return Math.random().toString(36).substr(2, 9);;
    },

    getConfig() {

        // return new Promise((resolve, reject) => {
        //     if (this.lsstore) {
        //         resolve();
        //     }
        //     let vm = this;
        //     try {
        //         vm.readTextFile('./static/js/i18n/lsstore.js', function (text) {
        //             var data = JSON.parse(text);
        //             vm.lsstore = data;
        //             resolve();
        //         });
        //     } catch (e) {
        //         reject();
        //     }
            // $.getJSON(url,  (r) => {
            //     this.lsstore = r;
            //     resolve(r);
            // })
            //     .fail(function (r) {
            //         reject(r);
            //     })
        // });
    },

    getMappingLocale(locale){
        if(locale=="en"){
            return "en";
        }else if(locale=="zh_CN"){
            return "sc";
        }else if(locale=="zh_HK"){
            return "tc";
        }else{
            return "en";
        }
    },
    readTextFile(file, callback) {
        var rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        }
        rawFile.send(null);
    },
    removeStorageItem(key) {
        if (window.localStorage.getItem(key)) {
            window.localStorage.removeItem(key);
        }
    },
    isNullOrUndefined: obj => {
        return isNullOrUndefined(obj);
    },
    wait(ms) {
        return new Promise(resolve => setTimeout(resolve(), ms));
    },
    showModal(ref) {
        if (ref) {
            $(ref).modal("show");
        }
    },
    hideModal(ref) {
        if (ref) {
            $(ref).modal("hide");
        }
    },
    capScreen(element, name) {

        html2canvas(element).then(function (canvas) {
            var a = document.createElement('a');
            a.href = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            a.download = name + '.png';
            a.click();
        });
    },

    formatDatetime(date) {
        return moment.utc(date).tz(this.getParam("region")).format(this.getParam("momentDateTimeFormat"));

    },
    hasAccess(code) {
        if (!this.getAccessName()) {
            return false;
        }

        if (code == "public") {
            return true;
        }
        let allAccessName = this.split2(this.getAccessName());
        let access = allAccessName.find(name => {
            let temp = name.replace("*", ".*");
            return code.match(`^${temp}$`);
        });

        return access ? true : false
    },

    // validateAccess(router, code) {

    // },


    upper(val) {
        if (val && typeof (val) == "string") {
            return val.toUpperCase();
        }
    },
    getStorageLanguages() {
            return ['en','zh_CN','zh_HK'];
    },
    getStoreageWords() {

        if (!this.lsstore || !this.lsstore.words) {
            return [];
        }
        return this.lsstore.words;
    },
    getStoreageParams() {
        if (!this.lsstore || !this.lsstore.params) {
            return [];
        }
        return this.lsstore.params;
    },
    getWord(word) {
        let locale = this.getLocaleCode();
        let words = this.getStoreageWords() || [];
        let rv = word;


        if (Array.isArray(words)) {
            let find = words.find(o => o.locale_code === locale && this.upper(o.id) === this.upper(word));
            if (!isNullOrUndefined(find)) {
                rv = find.word;
            }
        }
        return rv;

    },
    getParam(name) {
        let params = this.getStoreageParams() || [];
        let rv = null;


        if (Array.isArray(params)) {
            let find = params.find(o => this.upper(o.name) === this.upper(name));
            if (!isNullOrUndefined(find)) {
                rv = find.value;
            }
        }
        return rv;

    },
    //for form only
    initFormGrid(page) {
        store.dispatch('grid/actionSetGrid', {
            gridId: page.gridId,
            filterItem: {
                reference_no: !isUndefined(page.$route.params.id) ? page.$route.params.id : "new"
            },
            isMainGrid: page.isMainGrid || true,
            startIndex: 0,
            pageNum: 0,
            pageSize: 0,
            totalRows: 0


        })
    },
    alert: (message) => {
        store.dispatch("message/actionSetMessageStrOnly", message);
    },
    checkViewMode() {
        let rv = true;
        let getViewMode = store.getters["grid/getViewMode"];
        if (!getViewMode) {
            this.alert("Please Apply the change");
            rv = false;
        }

        return rv;
    },
    getGrid: id => {
        return _.cloneDeep(store.getters["grid/getGridById"](id));
    },
    initGrid(page, baseUrl) {
        store.dispatch('grid/actionSetGrid', {
            gridId: page.gridId,
            isMainGrid: page.isMainGrid || true,
            startIndex: 0,
            pageNum: 0,
            pageSize: 0,
            totalRows: 0,
            baseUrl: baseUrl
        })
    },
    defaultFilerValue(gridId, key, value) {
        let grid = this.getGrid(gridId);
        this.write(grid);
        if (!grid || !key || !value) {
            alert("no grid / key / value")
            return;
        }
        grid.filterItem[key] = value;
        store.dispatch('grid/actionSetGrid', {
            gridId: gridId,
            filterItem: grid.filterItem,
        })

    },
    addModalZindex: () => {
        $("head").append("<style class='modalZindex'>.modal{z-index: 1200;}.modal-backdrop{z-index: 1150;}.highZindex{z-index: 1100;}</style>")

    },
    write: (obj) => {
        console.log(obj);
    },
    removeModalZindex: () => {
        $('.modalZindex').remove()
    },
    measurementModalZindex: () => {
        $("head").append("<style class='modalZindex'>.highZindex{z-index: 1040;}</style>")

    },
    getLocaleCode() {

            if (window.localStorage.getItem("locale")) {
                return window.localStorage.getItem("locale");
            }
            return this.getParam("defaultLocale");
    },

    getSessionID() {
        return this.getUser() ? this.getUser().session_id : null;
    },
    getUserID() {
        return this.getUser() ? this.getUser().user_id : null;
    },
    getAccessName() {
        return this.getUser() ? this.getUser().access_name : null;
    },

    loading: (ref) => {
        let e = ref ? ref : "#mainWrapper"
        NProgress.start();
        $(e).block({
            message: '<i class="fa fa-circle-notch spinner-icon2"></i>',
            overlayCSS: {
                backgroundColor: 'none',
                opacity: 0.8,
                cursor: 'wait',
                'box-shadow': '0 0 0 0px #ddd'
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
            }
        })



    },

    done: (ref) => {
        let e = ref ? ref : "#mainWrapper"
        NProgress.done();
        $(e).unblock();
    },

    join: (obj, key) => {
        if (obj[key] && Array.isArray(obj[key])) {
            obj[key] = obj[key].join(",");
        }
    },
    joinVal(val) {
        let rv = val;
        if (val && Array.isArray(val)) {
            rv = val.join(",");
        }
        return rv;
    },
    joinObj(obj) {
        let rv = obj;
        if (rv) {
            Object.entries(rv).forEach(([key, v]) => {
                if (v && Array.isArray(v)) {
                    rv[key] = this.joinVal(v);
                }
            })
        }
        return rv;
    },
    split: (obj, key) => {
        if (obj[key] && typeof (obj[key]) == "string") {
            obj[key] = obj[key].split(",");
        }

        if (obj[key] && typeof (obj[key]) == "boolean") {
            obj[key] = `${obj[key]}`;
            obj[key] = obj[key].split(",");
        }


    },

    split2: (obj) => {
        let rv = null
        if (obj && typeof (obj) == "string") {
            rv = obj.split(",");
        }

        if (obj && typeof (obj) == "boolean") {
            rv = `${obj}`;
            rv = rv.split(",");
        }

        return rv;

    },
    clearVuex(store) {
        store.dispatch("grid/actionSetViewMode", true);
        store.dispatch("grid/actionSetToggleGridResize", false);
        store.dispatch("grid/actionResetAllGrid");
        store.dispatch("filters/actionReSetFilterMode");
        store.dispatch("filters/actionResetData");
        store.dispatch("actioResetlinkHandling");
        store.dispatch("message/actionResetMessage");
        store.dispatch("actionSetForceBlock", true);
    },
    findNow(page) {
        if (!page || !page.gridId) {
            alert("no page / grid id");
        }
        store.dispatch("grid/actionSetLoading", {
            gridId: page.gridId,
            loading: true
        })
        store.dispatch("filters/actionFindNowById", { page: page, gridId: page.gridId }).then(res => {
            store.dispatch("grid/actionSetLoading", {
                gridId: page.gridId,
                loading: false
            })
        }).catch(ex => {
            store.dispatch("grid/actionSetLoading", {
                gridId: page.gridId,
                loading: false
            })
        });
    },
    isValidDate(value) {
        var dateWrapper = new Date(value);
        return !isNaN(dateWrapper.getDate());
    },
    toShortDateString(value) {
        if (isValidDate(value)) {
            return moment(value).format('YYYY-MM-DD');
        } else {
            return value;
        }

    },
    clearData: page => {
        Object.assign(page.$data, page.$options.data.apply(page))
    },
    getBase64: file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
        //  const reader = new FileReader();
        // reader.readAsDataURL(file);
        // return reader.result
        // reader.onload = () => resolve(reader.result);

    },
    removeAt: (arr, str, type) => {
        if (!arr || !str || !type) {
            return;
        }

        if (type == "string") {
            let index = arr.indexOf(str);
            if (index > -1) {
                arr.splice(index, 1);
            }
        }

    },
    disableAt: (arr, str, type) => {
        if (!arr || !str || !type) {
            return;
        }
        if (type == "array") {
            arr.forEach(obj => {
                if (obj.Key == str) {
                    obj.disable = true
                }
            })

        }
    },
    enableAt: (arr, str, type) => {
        if (!arr || !str || !type) {
            return;
        }
        if (type == "array") {
            arr.forEach(obj => {
                if (obj.Key == str) {
                    obj.disable = false
                }
            })

        }
    },
    setChildValid: children => {
        //set page child valid
        let valid = true;
        children.forEach(c => {
            if (c.setStartToWatch) {
                c.setStartToWatch(true);
            }
            if (c.isFieldValid && !c.isFieldValid()) {
                if (c.setFocus && valid) {
                    c.setFocus();
                }
                valid = false;
                if (c.setValid) {
                    c.setValid(false);
                }
            } else if (c.setValid) {
                c.setValid(true);
            }

            if (c.isFieldFormatValid && !c.isFieldFormatValid()) {
                // focus on first field of error
                if (c.setFocus && valid) {
                    c.setFocus();
                }

                valid = false;

                if (c.setFormatValid) {
                    c.setFormatValid(false);
                }
            } else if (c.setFormatValid) {
                c.setFormatValid(true);
            }
        })

        return valid;
    },
    addModalZindex: () => {
        $("head").append("<style class='modalZindex'>.modal{z-index: 1200;}.modal-backdrop{z-index: 1150;}.highZindex{z-index: 1100;}</style>")

    },
    includes: (arr, str) => {
        if (!arr || !str) {
            return false;
        }
        return arr.indexOf(str) !== -1;
    },
    removeModalZindex: () => {
        $('.modalZindex').remove()
    },
    measurementModalZindex: () => {
        $("head").append("<style class='modalZindex'>.highZindex{z-index: 1040;}</style>")

    },


    scrollToTop: msg => {
        if (msg == null && msg == undefined) {
            $("html,body").animate({ scrollTop: 0 }, "fast")
        } else {
            if (msg !== "") {
                $("html,body").animate({ scrollTop: 0 }, "fast")
            }
        }
    },
    stopKeyDown: () => {
        $(document).keydown(function (e) {
            e.returnValue = true;
            e.stopPropagation();
            return true
        });
        $(document).off("keydown");
    },
    setFormBuilderMenu(isShow) {
        store.dispatch("actionSetFormBuilderMenu", isShow);
    },
}


export default helper
